import { createFileRoute } from "@tanstack/react-router";
import { InfrastructurePage, type InfraTab } from "../../../features/infrastructure/infrastructure-page";

const TABS: InfraTab[] = ["clouds-all", "spend", "forecast", "savings", "offer", "execution", "capacity", "pools", "approvals", "nodes", "clouds"];

export const Route = createFileRoute("/_authed/$org/$project/pools/")({
  validateSearch: (s: Record<string, unknown>): { tab?: InfraTab } =>
    TABS.includes(s.tab as InfraTab) ? { tab: s.tab as InfraTab } : {},
  component: PoolsPage,
});

function PoolsPage() {
  const { org, project } = Route.useParams();
  const { tab } = Route.useSearch();
  return <InfrastructurePage org={org} project={project} tab={tab ?? "clouds"} />;
}
